import { createServerFn } from "@tanstack/react-start";
import {
  getPublicUrl as _getPublicUrl,
  getSignedUrl as _getSignedUrl,
} from "~/lib/image-helpers";
import { z } from "zod";

const GetSignedUrlSchema = z.object({
  filename: z.string().min(1, "filename is required"),
  contentType: z.string().min(1, "contentType is required"),
});

const GetPublicUrlSchema = z.object({
  blobName: z.string().min(1, "blobName is required"),
});

/**
 * Generates a signed URL for uploading a file to GCS.
 * @param filename - Original file name.
 * @param contentType - MIME type of the file.
 * @returns An object containing the signed URL and blob name.
 */
export const getSignedUrl = createServerFn({ method: "POST" })
  .validator(GetSignedUrlSchema)
  .handler(async ({ data }) => {
    const { filename, contentType } = data;
    const { serverEnv } = await import("~/lib/server-env");
    const credentials = serverEnv.GOOGLE_APPLICATION_CREDENTIALS;
    if (!credentials) {
      throw new Error("Google application credentials not found");
    }
    return _getSignedUrl(filename, contentType, credentials);
  });

/**
 * Constructs the public URL for a given blob name.
 * @param blobName - The name of the blob in GCS.
 * @returns The public URL of the image.
 */
export const getPublicUrl = createServerFn({ method: "POST" })
  .validator(GetPublicUrlSchema)
  .handler(({ data }) => {
    const { blobName } = data;
    return _getPublicUrl(blobName);
  });
